import validate from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45root_45redirect_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/01.rootRedirect.global.ts";
import _03_45login_45state_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/03.loginState.global.ts";
import self_45service_45storage_45clear_45global from "/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/selfServiceStorageClear.global.ts";
import manifest_45route_45rule from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45root_45redirect_45global,
  _03_45login_45state_45global,
  self_45service_45storage_45clear_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "fsf-data-handler": () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/fsfDataHandler.ts"),
  "is-valid-sb-url": () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/middleware/isValidSBUrl.ts")
}